import { InjectionToken } from '@angular/core';
import type { Observable } from 'rxjs';

export const BUSINESS_INTELLIGENCE_REPRESENTATION_CONFIG = new InjectionToken<Observable<any>>(
    'BUSINESS_INTELLIGENCE_REPRESENTATION_CONFIG'
);
